module.exports = __webpack_public_path__ + "img/kessel.87d441b3.jpg";